(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const loadDeferredVideo = (slide) => {
      if (slide.querySelector('video')) return;

      const template = slide.querySelector('[data-cinematic-video-template]');
      if (!template) return;

      const video = template.content.firstElementChild?.cloneNode(true);
      if (!video) return;

      slide.querySelector('.cinematic-hero__media')?.appendChild(video);
    };

    const setVideoState = (slide, shouldPlay) => {
      if (shouldPlay) loadDeferredVideo(slide);

      const video = slide.querySelector('video');
      if (!video) return;

      const enableVideoAudio = slide.closest('[data-cinematic-slideshow]')?.dataset.videoAudio === 'true';

      if (shouldPlay) {
        video.muted = !enableVideoAudio;
        if (enableVideoAudio) return;
        video.play().catch(() => {});
      } else {
        video.pause();
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
      video.load();
      video.remove();
      }
    };

    const setupHero = (hero) => {
      if (hero.dataset.cinematicReady === 'true') return;
      hero.dataset.cinematicReady = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-cinematic-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-cinematic-dot]'));
      const nextButton = hero.querySelector('[data-cinematic-next]');
      const prevButton = hero.querySelector('[data-cinematic-prev]');
      const enableVideoAudio = hero.dataset.videoAudio === 'true';
      const autoplay = hero.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
      const interval = Number(hero.dataset.interval) || 7000;
      let activeIndex = 0;
      let timer;

      const goTo = (nextIndex, options = {}) => {
        activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        if (index !== activeIndex) {
          const inactiveVideo = slide.querySelector('video');
          if (inactiveVideo) {
            inactiveVideo.pause();
            inactiveVideo.remove();
          }
        }
      });

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          if (isActive && options.deferActiveVideo) return;
          setVideoState(slide, isActive);
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (autoplay) {
          timer = window.setInterval(() => goTo(activeIndex + 1), interval);
        }
      };

      nextButton?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        start();
      });

      prevButton?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        start();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.cinematicDot));
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
          goTo(activeIndex);
        }
      });

      goTo(0, { deferActiveVideo: true });
      const loadInitialVideo = () => {
        window.setTimeout(() => setVideoState(slides[activeIndex], true), 900);
      };
      if (document.readyState === 'complete') {
        loadInitialVideo();
      } else {
        window.addEventListener('load', loadInitialVideo, { once: true });
      }
      start();
    };

    document.querySelectorAll('[data-cinematic-slideshow]').forEach(setupHero);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cinematic-slideshow]').forEach(setupHero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-size-selector] .product-form__size-input');

    if (!input) return;

    const form = input.closest('form');
    const section = input.closest('.main-product');
    const selectedVariantInput = form?.querySelector('[data-selected-variant-id]');
    const hiddenSelect = form?.querySelector('.product-form__variant-select');
    const selectedSize = form?.querySelector('[data-selected-size]');
    const price = section?.querySelector('.main-product__price');
    const submitButton = form?.querySelector('.product-form__submit');
    const inventory = form?.querySelector('[data-product-inventory]');
    const inventoryMessage = form?.querySelector('[data-product-inventory-message]');

    if (selectedVariantInput) selectedVariantInput.value = input.value;
    if (hiddenSelect) hiddenSelect.value = input.value;
    if (selectedSize) selectedSize.textContent = input.dataset.variantTitle || '';
    if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;
    if (submitButton) submitButton.disabled = input.disabled;
    if (inventory && inventoryMessage) {
      inventory.classList.remove(
        'product-form__inventory--available',
        'product-form__inventory--low-stock',
        'product-form__inventory--out-of-stock'
      );
      inventory.classList.add(`product-form__inventory--${input.dataset.inventoryStatus || 'available'}`);
      inventoryMessage.textContent = input.dataset.inventoryMessage || 'Disponible';
    }
  });

  document.querySelectorAll('[data-product-zoom]').forEach((section) => {
    const modal = section.querySelector('[data-product-zoom-modal]');
    const image = section.querySelector('[data-product-zoom-image]');
    const triggers = Array.from(section.querySelectorAll('[data-product-zoom-open]'));
    let activeIndex = 0;
    let focusedElement = null;

    if (!modal || !image || !triggers.length) return;

    const showImage = (index) => {
      activeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[activeIndex];
      image.src = trigger.dataset.zoomSrc || '';
      image.alt = trigger.dataset.zoomAlt || '';
    };

    const openZoom = (index, trigger) => {
      focusedElement = trigger || document.activeElement;
      showImage(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-zoom-open');
      modal.querySelector('[data-product-zoom-close]')?.focus();
    };

    const closeZoom = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-zoom-open');
      image.removeAttribute('src');

      if (focusedElement && document.contains(focusedElement)) {
        focusedElement.focus();
      }
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => openZoom(index, trigger));
    });

    modal.querySelectorAll('[data-product-zoom-close]').forEach((button) => {
      button.addEventListener('click', closeZoom);
    });

    modal.querySelector('[data-product-zoom-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
    modal.querySelector('[data-product-zoom-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeZoom();
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
